/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdprivate9Inputs */

const en__field_enum_sdprivate9 = /** @type {(inputs: _Field_Enum_Sdprivate9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private`)
};

const de__field_enum_sdprivate9 = /** @type {(inputs: _Field_Enum_Sdprivate9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privat`)
};

/**
* | output |
* | --- |
* | "Private" |
*
* @param {_Field_Enum_Sdprivate9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdprivate9 = /** @type {((inputs?: _Field_Enum_Sdprivate9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdprivate9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdprivate9(inputs)
	return de__field_enum_sdprivate9(inputs)
});
export { _field_enum_sdprivate9 as "_field_enum_SDPRIVATE" }